import { jsx as _jsx } from "react/jsx-runtime";
import { CardHeader } from '@material-ui/core';
import cx from 'clsx';
export function QAHeader(_a) {
    var title = _a.title, titleClass = _a.titleClass, avatar = _a.avatar;
    return (_jsx(CardHeader, { title: title, titleTypographyProps: {
            className: cx(titleClass, 'faq-panel-header__title'),
            variant: 'h3',
            component: 'h3',
        }, className: cx('faq-panel-header'), avatar: avatar }));
}
//# sourceMappingURL=QAHeader.js.map